import type { CommunityPostEventCreateRequest, CommunityPostEventTypeDto } from "@/api/types";

type EventFormValues = {
  hasDate: "yes" | "no" | undefined;
  eventType: CommunityPostEventTypeDto | undefined;
  eventStartsAt: Date | undefined;
  eventEndsAt: Date | undefined;
  eventLocation: string;
  eventMaxParticipants: string;
  eventNoParticipantsLimit: boolean;
  eventAllowGuests: boolean;
};

export function toCommunityPostEvent({
  hasDate,
  eventType,
  eventStartsAt,
  eventEndsAt,
  eventLocation,
  eventMaxParticipants,
  eventNoParticipantsLimit,
  eventAllowGuests,
}: EventFormValues): CommunityPostEventCreateRequest | undefined {
  if (hasDate !== "yes" || !eventType || !eventStartsAt || !eventEndsAt) {
    return undefined;
  }

  const location = eventLocation.trim();

  return {
    type: eventType,
    startsAt: eventStartsAt.toISOString(),
    endsAt: eventEndsAt.toISOString(),
    ...(location && { location }),
    ...(eventType === "common" &&
      !eventNoParticipantsLimit && {
        maxParticipants: Number(eventMaxParticipants),
      }),
    ...(eventType === "common" && !eventAllowGuests && { maxGuestsPerParticipant: 0 }),
  };
}
